import { atom } from 'recoil';

export interface CampaignInfo {
  campaignId: string;
  campaignType: string;
}
export const campaignInfoAtom = atom<CampaignInfo>({
  default: {
    campaignId: '',
    campaignType: '',
  },
  key: 'CampaignInfoAtom',
});
